module.exports = __webpack_public_path__ + "static/img/help-chart.7fd3b03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/partnership/help-chart.jpg
// module id = lNZv
// module chunks = 2